var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolDebtRecovery01 = function SvgSolDebtRecovery01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_debt_recovery-01_svg2__a",
    x1: 39.09,
    x2: 192.69,
    y1: 193.79,
    y2: 27.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_debt_recovery-01_svg2__a",
    id: "sol_debt_recovery-01_svg2__b",
    x1: 43.1,
    x2: 196.7,
    y1: 197.5,
    y2: 31.48
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_debt_recovery-01_svg2__a",
    id: "sol_debt_recovery-01_svg2__c",
    x1: -0.92,
    x2: 152.68,
    y1: 156.78,
    y2: -9.25
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_debt_recovery-01_svg2__a",
    id: "sol_debt_recovery-01_svg2__d",
    x1: 66.33,
    x2: 219.93,
    y1: 218.99,
    y2: 52.97
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M125.3 101.58c-.1-.16-.21-.31-.35-.45s-.29-.25-.45-.35c-.16-.12-.33-.19-.51-.27a2 2 0 0 0-.54-.17c-.95-.19-1.96.14-2.62.8-.13.14-.25.29-.37.45-.1.16-.2.33-.27.5-.06.17-.12.37-.16.54-.04.19-.06.39-.06.56 0 .19.02.39.06.58.04.17.1.37.16.54.08.17.17.35.27.5.12.16.23.31.37.45.14.12.27.25.45.35.16.12.31.19.49.27.17.08.37.14.54.16.2.04.39.06.58.06s.37-.02.56-.06c.19-.02.37-.08.54-.16.18-.08.35-.16.51-.27.16-.1.31-.23.45-.35.14-.14.25-.29.35-.45.12-.16.2-.33.27-.5a2.8 2.8 0 0 0 .17-1.68c-.04-.17-.1-.37-.17-.54-.08-.17-.16-.35-.27-.5Z",
    style: {
      fill: "url(#sol_debt_recovery-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.98 68.96c.54-.54.86-1.3.86-2.08s-.31-1.51-.86-2.04c-1.09-1.11-3.03-1.09-4.12 0-.54.52-.85 1.28-.85 2.04s.31 1.53.85 2.08c.54.52 1.3.83 2.06.83s1.52-.31 2.06-.83",
    style: {
      fill: "url(#sol_debt_recovery-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.56 66.06v-5.77h5.64c1.91 1.33 3.89 2.58 5.9 3.76V96.8c0 5.14 4.18 9.32 9.32 9.32h43.72c1.61 0 2.91-1.3 2.91-2.91s-1.3-2.91-2.91-2.91H75.08c-1.19-8.9-8.24-15.96-17.15-17.15V67.2c8.07 4 16.72 6.86 25.56 8.39l14.26 2.48c.73.13 1.45.19 2.17.19 1.27 0 2.51-.19 3.68-.56 3.87 6.96 11.16 11.31 19.3 11.31 12.2 0 22.12-9.92 22.12-22.12s-9.92-22.12-22.12-22.12c-7.2 0-13.84 3.46-17.97 9.21L85.71 43.35a5.28 5.28 0 0 1-2.72-4.62c0-2.91 2.37-5.28 5.28-5.28h82.45c1.19 8.9 8.24 15.96 17.15 17.15v32.55c-8.9 1.19-15.96 8.24-17.15 17.15h-30.06c-1.61 0-2.91 1.3-2.91 2.91s1.3 2.91 2.91 2.91h43.72c5.14 0 9.32-4.18 9.32-9.32V36.94c0-5.14-4.18-9.32-9.32-9.32h-52.2l-19.99-15.41c-4.93-3.8-11.08-5.9-17.31-5.9H40.56v-3.4c0-1.61-1.3-2.91-2.91-2.91H2.91C1.3 0 0 1.3 0 2.91v63.15c0 1.61 1.3 2.91 2.91 2.91h34.73c1.61 0 2.91-1.3 2.91-2.91Zm28.62 34.23h-7.77a3.5 3.5 0 0 1-3.49-3.49v-7.77a14.19 14.19 0 0 1 11.26 11.26m53.71-49.69c8.99 0 16.3 7.31 16.3 16.3s-7.31 16.3-16.3 16.3c-6.04 0-11.43-3.25-14.27-8.43 1.35-1.28 2.43-2.88 3.11-4.72 1.61-4.33.66-9.12-2.17-12.52a16.25 16.25 0 0 1 13.33-6.93m61.48 49.69h-7.77a14.19 14.19 0 0 1 11.26-11.26v7.77c0 1.93-1.57 3.49-3.49 3.49m3.49-63.35v7.77a14.19 14.19 0 0 1-11.26-11.26h7.77a3.5 3.5 0 0 1 3.49 3.49m-92.99-24.8c4.95 0 9.83 1.66 13.75 4.69l14.01 10.8H88.26c-6.12 0-11.1 4.98-11.1 11.11 0 4.04 2.2 7.76 5.73 9.72l20.3 11.23c2.92 1.62 4.25 5.2 3.08 8.33a6.796 6.796 0 0 1-7.54 4.32l-14.26-2.48C71.7 67.64 59.36 62.5 48.79 55.01c-.49-.35-1.08-.54-1.68-.54h-6.56V12.14zM34.73 63.15H5.83V5.83h28.91v57.32Z",
    style: {
      fill: "url(#sol_debt_recovery-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.09 131.03h-34.73c-1.61 0-2.91 1.3-2.91 2.91v1.15a36.35 36.35 0 0 0-17.52-4.48c-10.84 0-21.06 4.75-28.04 13.04l-4.28 5.08H86.05c-6.99 0-12.68 5.69-12.68 12.68 0 1.88.42 3.66 1.16 5.27a31.35 31.35 0 0 1-12.31-7.6l-19.19-19.19c-4.93-4.94-12.98-4.95-17.93-.04-2.42 2.4-3.76 5.59-3.76 9s1.31 6.61 3.72 9.02l21.44 21.44c10.29 10.29 23.97 15.95 38.52 15.95h74.44v1.82c0 1.61 1.3 2.91 2.91 2.91h34.73c1.61 0 2.91-1.3 2.91-2.91v-63.15c0-1.61-1.3-2.91-2.91-2.91ZM85.01 189.44c-12.99 0-25.21-5.06-34.4-14.25l-21.44-21.44a6.89 6.89 0 0 1-2.02-4.88c0-1.84.73-3.57 2.04-4.87 2.69-2.66 7.04-2.65 9.71.02l19.19 19.19c7.03 7.03 16.37 10.9 26.3 10.9h44.62c1.61 0 2.91-1.3 2.91-2.91s-1.3-2.91-2.91-2.91H86.03c-3.78 0-6.86-3.08-6.86-6.86s3.08-6.86 6.86-6.86h24.92c.86 0 1.67-.38 2.23-1.04l5.15-6.12a30.78 30.78 0 0 1 23.59-10.97c6.31 0 12.35 1.9 17.52 5.48v47.52H85Zm109.16 4.73h-28.9v-57.32h28.9z",
    style: {
      fill: "url(#sol_debt_recovery-01_svg2__d)"
    }
  }));
};
export default SvgSolDebtRecovery01;